module.exports = __webpack_public_path__ + "img/Animation.47463216.gif";